var script = {
  name: 'Material',
  inheritAttrs: false,
  props: {
    spinnerProps: {
      type: Object,
      default: () => ({})
    }
  }
};

export { script as default };
//# sourceMappingURL=material.vue2.js.map
